import LoginSocialBarSdk from '../components/LoginSocialBar/corvid/LoginSocialBar.corvid';


const LoginSocialBar = {
  sdk: LoginSocialBarSdk
};


export const components = {
  ['LoginSocialBar']: LoginSocialBar
};

